document.addEventListener('DOMContentLoaded', function () {
  // start home video after loader fade (2.5s)
  setTimeout(function () {
    var v = document.getElementById('home-video');
    if (!v) return;
    // ensure muted for autoplay policies
    v.muted = true;
    v.loop = true;
    // reset and play
    try {
      v.currentTime = 0;
    } catch (e) {}
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // play failure (user gesture required) — ignore silently
      });
    }
  }, 2500);
});